module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjZmZmIj48cGF0aCBkPSJNNDQwLTE2MEgyNjBxLTkxIDAtMTU1LjUtNjNUNDAtMzc3cTAtNzggNDctMTM5dDEyMy03OHEyNS05MiAxMDAtMTQ5dDE3MC01N3ExMTcgMCAxOTguNSA4MS41VDc2MC01MjBxNjkgOCAxMTQuNSA1OS41VDkyMC0zNDBxMCA3NS01Mi41IDEyNy41VDc0MC0xNjBINTIwdi0yODZsNjQgNjIgNTYtNTYtMTYwLTE2MC0xNjAgMTYwIDU2IDU2IDY0LTYydjI4NloiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/deployments-24px.svg
// module id = W8xZ
// module chunks = 1